import { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { LaunchPad } from './components/LaunchPad';
import { ThemeProvider } from './components/ThemeProvider';
import config from './config';
import { redirectToLogin } from './lib/auth';

import '@launchpad-ui/tokens/src/generated/fonts.css';
import '@launchpad-ui/tokens/src/generated/index.css';
import '@launchpad-ui/tokens/src/generated/themes.css';
import './global.scss';

const queryClient = new QueryClient();

type AuthState = 'loading' | 'ready' | 'redirecting';

export function App() {
  const [authState, setAuthState] = useState<AuthState>('loading');

  useEffect(() => {
    fetch(`${config.gonfalon.host}/private/caller-identity`, { credentials: 'include' })
      .then((res) => (res.ok ? setAuthState('ready') : setAuthState('redirecting')))
      .catch(() => setAuthState('redirecting'));
  }, []);

  useEffect(() => {
    if (authState === 'redirecting') {
      redirectToLogin();
    }
  }, [authState]);

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>{authState === 'ready' ? <LaunchPad /> : null}</QueryClientProvider>
    </ThemeProvider>
  );
}
